import type { Effect, Reducer } from 'umi';

export interface LocationState {
  refreshIndex: number,
};
export interface LocationStateType {
  namespace: 'locationState',
  state: LocationState,
  reducers: Record<string, Reducer>,
  effects: Record<string, Effect>,
};

const LocationStateModel: LocationStateType = {
  namespace: 'locationState',
  state: {
    refreshIndex: -1,
  },
  reducers: {
    setRefreshIndex (state, { payload }) {
      state.refreshIndex = payload;
    }
  },
  effects: {
    *reloadPage ({ payload }, { put }) {
      yield put({ type: 'setRefreshIndex', payload })
    },
    *resetRefreshIndex (_, { put }) {
      yield put({ type: 'setRefreshIndex', payload: -1 })
    }
  },
}

export default LocationStateModel;
